import { createSelector } from 'reselect';
import { AppState } from '../..';
import { LayerConfig } from './map-settings.models';

export const getIs3dEnabled = createSelector(
  (state: AppState) => state.mapSettings.is3dEnabled,
  (is3dEnabled) => is3dEnabled,
);

const getSelectedLayerNames = (allLayerSettings: LayerConfig) =>
  Object.keys(allLayerSettings).filter(
    (layerName) => !!allLayerSettings[layerName],
  );

export const getSelectedLayers = createSelector(
  (state: AppState) => state.mapSettings.layerSettings,
  getSelectedLayerNames,
);
